/*
 * @Author: Rowe 
 * @Date: 2019-05-09 17:34:52 
 * @Last Modified by: Rowe
 * @Last Modified time: 2019-05-09 17:42:27
 */
'use strict'

import { CATEGORY } from "../constants/ActionTypes";

const initState = {

    POPUP_REQUEST : null,  // v修改后
    CATEGORY_POPUP : null, // v修改后
    POPUP_ORDER_NUM : 1,   // v修改后
    FILTER_STATUS : null,  // v修改后
    SHOW_ALL : false,      // v修改后 
    FIXEDTOP_SHOW : 1,     // v修改后
    BOTTOM : false,        // v修改后
    GET_BRANDS:null,       // v修改后
    SAVE_VALUE:null,       // v修改后
    LACK_INV:null,         // v修改后
    SHOW_SUCCESS : 0,      // v修改后
    GETADBANNER : null,    // v修改后

    SORT_PRODUCT:null,
    SET_OFFSETTOP:null,
    IFSHOW:true
}

export default function ( state = initState, action = {} ){

    switch( action.type ){
        case CATEGORY.SAVE_VALUE:              // not modified
        return Object.assign({},state,{
            SAVE_VALUE:action.value
        })
        break;
        case CATEGORY.SHOW_SUCCESS:              // v 修改后
        return Object.assign({},state,{
            SHOW_SUCCESS:action.num
        })
        break;
        case CATEGORY.GETADBANNER:              // v 修改后
        return Object.assign({},state,{
            GETADBANNER:action.data
        })
        break;

        case CATEGORY.LACK_INV:              // v 修改后
        return Object.assign({},state,{
            LACK_INV:action.value
        })
        break;

        case CATEGORY.GET_BRANDS:               // v 修改后
        return Object.assign({},state,{
            GET_BRANDS:action.json
        })
        break;

         case CATEGORY.CONTROL_BOTTOM:          // v 修改后
            return  Object.assign({},state,{
                BOTTOM : action.Boolean
            })
        break;

         case CATEGORY.TOGGLE_SHOW_ALL:          // v 修改后
            return  Object.assign({},state,{
                SHOW_ALL : action.Boolean
            })
        break;

        case CATEGORY.POPUP_REQUEST:          // v 修改后
            return  Object.assign({},state,{
                POPUP_REQUEST : action.POPUP_REQUEST,
                POPUP_ORDER_NUM : 1
            })
        break;

        case CATEGORY.CATEGORY_POPUP:       // v 修改后
        return Object.assign({},state,{
           CATEGORY_POPUP:action.show
        })
        break;

        case CATEGORY.POPUP_ORDER_NUM:       // v 修改后
        return Object.assign({},state,{
           POPUP_ORDER_NUM:action.num
        })
        break;

        case CATEGORY.FILTER_STATUS:       // v 修改后
        return Object.assign({},state,{
           FILTER_STATUS:action.params
        })
        break;

	case CATEGORY.HIDE_FIXED_TOP:           // v 修改后
        return Object.assign({},state,{
           FIXEDTOP_SHOW:action.num
        })
        break;
    case CATEGORY.SET_OFFSETTOP:
        return Object.assign({},state,{
           SET_OFFSETTOP:action.value
        })
        break;
        
    case CATEGORY.IFSHOW:
        return Object.assign({},state,{
            IFSHOW:action.value
        })
        break;
    
    case CATEGORY.SORT_PRODUCT:
        return Object.assign({},state,{
            SORT_PRODUCT:action.param
        })
        break;
        
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./common/reducers/category.js